import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Progress } from './ui/progress';

const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_5935cf64-512e-4adb-972b-b8d08d999032/artifacts/9m3z1jc8_thumbnail_PHOTO-2025-02-05-22-08-51.jpg';

/**
 * Shared layout for onboarding questions. Mobile-first, max-w-md.
 */
const OnboardingLayout = ({ step, total = 5, title, subtitle, children, testId }) => {
  const pct = Math.round((step / total) * 100);
  return (
    <div className="min-h-screen bg-background flex flex-col" data-testid={testId}>
      {/* Top bar */}
      <header className="px-5 pt-5 pb-3">
        <div className="max-w-md mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img
              src={LOGO_URL}
              alt="Sturent"
              className="h-9 w-9 rounded-xl object-cover shadow-sm"
            />
            <span className="font-heading font-bold text-base text-slate-900">Sturent</span>
          </Link>
          <span className="text-xs font-medium text-slate-500" data-testid="onboarding-step-counter">
            Step {step} of {total}
          </span>
        </div>
      </header>

      {/* Progress */}
      <div className="px-5">
        <div className="max-w-md mx-auto">
          <Progress
            value={pct}
            className="h-1.5 bg-amber-100 [&>div]:bg-amber-500"
            data-testid="onboarding-progress-bar"
          />
        </div>
      </div>

      {/* Content */}
      <main className="flex-1 px-5 pt-8 pb-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="max-w-md mx-auto"
        >
          <h1 className="text-2xl sm:text-3xl font-heading font-extrabold text-slate-900 leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-2 text-sm sm:text-base text-slate-600 leading-relaxed">{subtitle}</p>
          )}
          <div className="mt-8">{children}</div>
        </motion.div>
      </main>
    </div>
  );
};

export default OnboardingLayout;
